import React, { useContext } from 'react'

export const ThingContext = React.createContext({})

export const useThingContext = () => {
  return useContext(ThingContext)
}
